function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 9,
  strokeWidth: 9,
  d: "M3.66 60.43L60.52 3.57M3.66 3.57l56.86 56.86"
});

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+Y2xvc2U8L3RpdGxlPjxsaW5lIHgxPSIzLjY2IiB5MT0iNjAuNDMiIHgyPSI2MC41MiIgeTI9IjMuNTciIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iOSIgc3Ryb2tlLXdpZHRoPSI5Ii8+PGxpbmUgeDE9IjMuNjYiIHkxPSIzLjU3IiB4Mj0iNjAuNTIiIHkyPSI2MC40MyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSI5IiBzdHJva2Utd2lkdGg9IjkiLz48L3N2Zz4=";
export { SvgClose as ReactComponent };